const user = {
  state: {
    basicInfo: null
  },
  actions: {
    async setBasicInfo (context, basicInfo) {
      context.state.basicInfo = basicInfo
    }
  }
}

export default user
